<div id="listCont">
  <div *ngFor="let store of storeList" class="line">
    <div
      *ngIf="store.idmatriz === null"
      title="{{ store.nome }} - Matriz{{ store.matriz }}"
      class="l1"
    >
      {{ store.nome }} -
      <span>Matriz{{ store.matriz }}</span>
    </div>
    <div
      *ngIf="store.idmatriz !== null"
      title="{{ store.nome }} - Filial{{ store.idestabelecimento }}"
      class="l1"
    >
      {{ store.nome }} -
      <span>Filial{{ store.idestabelecimento }}</span>
    </div>
    <div class="l2">
      <img src="assets/img/icon-order-lineal.svg" alt="" />
      <div class="lDetail">
        {{ store.total_order | number }}
        <span *ngIf="store.total_order_porcent === 0" [style.color]="'#b5cad9'"
          >{{ store.total_order_porcent }}%</span
        >
        <span
          *ngIf="store.total_order_porcent > 0"
          [style.color]="'rgb(0, 201, 151)'"
          ><img src="assets/img/arrow-green.svg" alt="" />{{
            store.total_order_porcent
          }}%</span
        >
        <span
          *ngIf="store.total_order_porcent < 0"
          [style.color]="'rgb(255, 115, 115)'"
          ><img src="assets/img/arrow-red.svg" alt="" />{{
            store.total_order_porcent
          }}%</span
        >
        <h4 *ngIf="store.total_order === 0 || store.total_order === 1">
          Pedido
        </h4>
        <h4 *ngIf="store.total_order > 1">Pedidos</h4>
      </div>
    </div>
    <div class="l3">
      <img src="assets/img/icon-revenue-lineal.svg" alt="" />
      <div class="lDetail">
        {{ store.total_sales | currency: "pt-br":"R$" }}
        <span *ngIf="store.total_sales_porcent === 0" [style.color]="'#b5cad9'"
          >{{ store.total_sales_porcent }}%</span
        >
        <span
          *ngIf="store.total_sales_porcent > 0"
          [style.color]="'rgb(0, 201, 151)'"
          ><img src="assets/img/arrow-green.svg" alt="" />{{
            store.total_sales_porcent
          }}%</span
        >
        <span
          *ngIf="store.total_sales_porcent < 0"
          [style.color]="'rgb(255, 115, 115)'"
          ><img src="assets/img/arrow-red.svg" alt="" />{{
            store.total_sales_porcent
          }}%</span
        >
        <h4>Receita</h4>
      </div>
    </div>
    <div class="l4">
      <img src="assets/img/icon-price-lineal.svg" alt="" />
      <div class="lDetail">
        {{ store.ticket | currency: "pt-br":"R$" }}
        <span *ngIf="store.ticket_porcent === 0" [style.color]="'#b5cad9'"
          >{{ store.ticket_porcent }}%</span
        >
        <span
          *ngIf="store.ticket_porcent > 0"
          [style.color]="'rgb(0, 201, 151)'"
          ><img src="assets/img/arrow-green.svg" alt="" />{{
            store.ticket_porcent
          }}%</span
        >
        <span
          *ngIf="store.ticket_porcent < 0"
          [style.color]="'rgb(255, 115, 115)'"
          ><img src="assets/img/arrow-red.svg" alt="" />{{
            store.ticket_porcent
          }}%</span
        >
        <h4>Ticket médio</h4>
      </div>
    </div>
    <div class="l5">
      <img src="assets/img/icon-smash-lineal.svg" alt="" />
      <div class="lDetail">
        {{ store.missing_products | number }}
        <span
          *ngIf="store.missing_products_porcent === 0"
          [style.color]="'#b5cad9'"
          >{{ store.missing_products_porcent }}%</span
        >
        <span
          *ngIf="store.missing_products_porcent > 0"
          [style.color]="'rgb(0, 201, 151)'"
          ><img src="assets/img/arrow-green.svg" alt="" />{{
            store.missing_products_porcent
          }}%</span
        >
        <span
          *ngIf="store.missing_products_porcent < 0"
          [style.color]="'rgb(255, 115, 115)'"
          ><img src="assets/img/arrow-red.svg" alt="" />{{
            store.missing_products_porcent
          }}%</span
        >
        <h4
          *ngIf="
            store.missing_products_past === 0 ||
            store.missing_products_past === 1
          "
        >
          Ruptura
        </h4>
        <h4 *ngIf="store.missing_products_past > 1">Rupturas</h4>
      </div>
    </div>
    <div class="l6">
      <div
        *ngIf="store.nps > 60"
        class="pointerBase"
        [style.transform]="'rotate(' + store.nps * 1.18 + 'deg)'"
      >
        <div class="pointerBall" [style.background]="'rgb(0 201 151)'"></div>
      </div>
      <div
        *ngIf="store.nps > 0 && store.nps <= 60"
        class="pointerBase"
        [style.transform]="'rotate(' + store.nps * 1.18 + 'deg)'"
      >
        <div class="pointerBall" [style.background]="'rgb(255 191 45)'"></div>
      </div>
      <div
        *ngIf="store.nps <= 0"
        class="pointerBase"
        [style.transform]="'rotate(' + store.nps * 1.18 + 'deg)'"
      >
        <div class="pointerBall" [style.background]="'rgb(255 115 115)'"></div>
      </div>
      <img
        class="meter"
        *ngIf="store.nps <= 0"
        src="assets/img/point-meter-chart-red-empty.svg"
        alt=""
      />
      <img
        class="meter"
        *ngIf="store.nps > 0 && store.nps <= 60"
        src="assets/img/point-meter-chart-yellow-empty.svg"
        alt=""
      />
      <img
        class="meter"
        *ngIf="store.nps > 60"
        src="assets/img/point-meter-chart-green-empty.svg"
        alt=""
      />
      <span>{{ store.nps | number: "1.0-0" }}</span>
      <h4>NPS</h4>
    </div>
  </div>
</div>
